export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/TmobileBussiness/theme/components/scorecard/ScorecardView/ScorecardExport.js